require('./bootstrap');
require('select2');
